module.exports = __webpack_public_path__ + "img/rs_fwt19-logo.96f8e67.png";